import { render } from "./ContentBlock.vue?vue&type=template&id=79f39fec&scoped=true&ts=true"
import script from "./ContentBlock.vue?vue&type=script&lang=ts"
export * from "./ContentBlock.vue?vue&type=script&lang=ts"

import "./ContentBlock.vue?vue&type=style&index=0&id=79f39fec&scoped=true&lang=scss"
import "./ContentBlock.vue?vue&type=style&index=1&id=79f39fec&lang=scss"
import "./ContentBlock.vue?vue&type=style&index=2&id=79f39fec&scoped=true&lang=scss"

import exportComponent from "/Users/saschas/dev/neurocure_website/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f39fec"]])

export default __exports__